<template>
  <v-btn @click="backStep()" color="grey lighten-2" depressed rounded block
    ><v-icon left>mdi-arrow-left</v-icon>Voltar
  </v-btn>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  methods: {
    ...mapMutations(["backStep"]),
  },
};
</script>

<style>
</style>